import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getPostsByCategory } from "@/mocks/posts";
import SectionHeading from "@/components/base/SectionHeading";

const accentMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function CategoryBoard() {
  return (
    <section id="categories" className="border-y border-background-200 bg-background-100">
      <div className="w-full px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="主题分类"
          title="六个方向 · 按兴趣直达"
          desc="每个方向都有独立的汇总清单，想看哪一类点进去就行，不用在信息流里翻找。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => {
            const count = getPostsByCategory(cat.id).length;
            return (
              <Link
                key={cat.id}
                to={`/summary?cat=${cat.id}`}
                className="group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
              >
                <div className="flex items-center justify-between">
                  <span
                    className={`flex h-11 w-11 items-center justify-center rounded-lg ${
                      accentMap[cat.accent] ?? accentMap.primary
                    }`}
                  >
                    <i className={`${cat.icon} text-xl`}></i>
                  </span>
                  <span className="flex items-center gap-1 text-sm text-foreground-500">
                    {count} 篇
                    <i className="ri-arrow-right-up-line transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                  {cat.name}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {cat.description}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}